/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemMethodNotAllowed } from './ProblemMethodNotAllowed';
import { ProblemMethodNotAllowedResourceAlive } from './ProblemMethodNotAllowedResourceAlive';
import { ProblemMethodNotAllowedResourceDeleted } from './ProblemMethodNotAllowedResourceDeleted';

export const MethodNotAllowedProblems: core.serialization.Schema<
    serializers.MethodNotAllowedProblems.Raw,
    Truvity.MethodNotAllowedProblems
> = core.serialization
    .union('type', {
        '/method-not-allowed': ProblemMethodNotAllowed,
        '/method-not-allowed/resource/alive': ProblemMethodNotAllowedResourceAlive,
        '/method-not-allowed/resource/deleted': ProblemMethodNotAllowedResourceDeleted,
    })
    .transform<Truvity.MethodNotAllowedProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace MethodNotAllowedProblems {
    export type Raw =
        | MethodNotAllowedProblems.MethodNotAllowed
        | MethodNotAllowedProblems.MethodNotAllowedResourceAlive
        | MethodNotAllowedProblems.MethodNotAllowedResourceDeleted;

    export interface MethodNotAllowed extends ProblemMethodNotAllowed.Raw {
        type: '/method-not-allowed';
    }

    export interface MethodNotAllowedResourceAlive extends ProblemMethodNotAllowedResourceAlive.Raw {
        type: '/method-not-allowed/resource/alive';
    }

    export interface MethodNotAllowedResourceDeleted extends ProblemMethodNotAllowedResourceDeleted.Raw {
        type: '/method-not-allowed/resource/deleted';
    }
}
